import { useState } from "react";
import Layout from "../components/Layout";

const logs = [
  { id: 1, recipient: "Jane Brown", message: "Your appointment is tomorrow at 10AM.", date: "2025-04-09" },
  { id: 2, recipient: "Daniel Scott", message: "Lab results are available.", date: "2025-04-01" },
  { id: 3, recipient: "All Users", message: "Clinic closed on Good Friday.", date: "2025-03-27" },
];

export default function MessagesNotifications() {
  const [broadcast, setBroadcast] = useState("");
const [recipient, setRecipient] = useState("All Users");
  const [logList, setLogList] = useState(logs);

  const handleSendBroadcast = () => {
    if (broadcast.trim()) {
      const newLog = {
      id: logList.length + 1,
      recipient,
        recipient: "All Users",
        message: broadcast,
        date: new Date().toISOString().split("T")[0],
      };
      setLogList([newLog, ...logList]);
      setBroadcast("");
    }
  };

  return (
    <Layout>
      <div className="p-6 space-y-6">
        <h1 className="text-2xl font-bold">Messages / Notifications</h1>

        <div className="bg-white p-4 rounded shadow space-y-4">
          <h2 className="text-lg font-semibold">Send Broadcast</h2>
          <select
  className="w-full border rounded p-2 mb-2"
  value={recipient}
  onChange={(e) => setRecipient(e.target.value)}
>
  <option>All Users</option>
  <option>Jane Brown</option>
  <option>Daniel Scott</option>
  <option>Amara Reid</option>
</select>

<textarea
  className="w-full border rounded p-2"
            rows={3}
            placeholder="Write a message to broadcast to all users"
            value={broadcast}
            onChange={(e) => setBroadcast(e.target.value)}
          ></textarea>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            onClick={handleSendBroadcast}
          >
            Send
          </button>
        </div>

        <div className="bg-white p-6 rounded-lg  shadow-lg">
          <h2 className="text-lg font-semibold mb-2">Notification Log</h2>
          <table className="w-full text-sm border">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">Recipient</th>
                <th className="p-2 border">Message</th>
                <th className="p-2 border">Date</th>
              </tr>
            </thead>
            <tbody>
              {logList.map(log => (
                <tr key={log.id} className="hover:bg-gray-50">
                  <td className="p-2 border">{log.recipient}</td>
                  <td className="p-2 border">{log.message}</td>
                  <td className="p-2 border">{log.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
